export type AiReviewState = "needs_review" | "reviewed" | "manual";

export type AiReviewFilter = "all" | AiReviewState;

export const ALL_ITEMS_REVIEW_FILTER: AiReviewFilter = "all";

export interface IAiReviewable {
  isDraftedFromSow?: boolean;
  importKey?: string;
}

export const getAiReviewState = (item: IAiReviewable): AiReviewState => {
  if (item.isDraftedFromSow) return "needs_review";
  return item.importKey ? "reviewed" : "manual";
};

export const filterByAiReviewState = <T extends IAiReviewable>(
  items: T[],
  filter: AiReviewFilter,
): T[] =>
  filter === ALL_ITEMS_REVIEW_FILTER
    ? items
    : items.filter((item) => getAiReviewState(item) === filter);

export const countNeedsReview = (items: IAiReviewable[]): number =>
  items.filter((item) => getAiReviewState(item) === "needs_review").length;

export const hasImportedItems = (items: IAiReviewable[]): boolean =>
  items.some((item) => getAiReviewState(item) !== "manual");
